import React, { useState } from "react";
import useLenis, { scrollToId } from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Impact from "@/components/site/Impact";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import BookDemo from "@/components/site/BookDemo";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [config, setConfig] = useState({
    apps: ["gestionale", "kitchen"],
    hoursPerDay: 10,
    daysPerWeek: 6,
    billing: "monthly",
    estimate: 0,
  });

  const handleRequest = (cfg) => {
    setConfig(cfg);
    scrollToId("contact");
  };

  return (
    <div className="grain relative bg-ink-bg min-h-screen">
      <Header />
      <main>
        <Hero />
        <Impact />
        <Marquee />
        <Products />
        <Manifesto />
        <Testimonials />
        <Pricing config={config} setConfig={setConfig} onRequest={handleRequest} />
        <BookDemo />
        <Contact config={config} />
      </main>
      <Footer />
    </div>
  );
}
